import { CartoLayer, colorBins } from "@deck.gl/carto";
import { selectSourceById, updateLayer } from "@carto/react-redux";
import { useCartoLayerProps } from "@carto/react-api";
import htmlForFeature from "utils/htmlForFeature";
import { setBreaksOrigins, setDataOrigins } from "store/appSlice";
import { useSelector, useDispatch } from "react-redux";
import { LEGEND_TYPES } from "@carto/react-ui";
import { VISITORS_LAYER_ID } from "components/layers/VisitorsLayer";
import { VISUALS } from "data/config.js";
import { getMinMaxQuantiles } from "data/models/model";
import { getEqualBreaks } from "utils/equalizer";

export const VISITORS_ORIGINS_LAYER_ID = "visitorsOriginsLayer";

export default function VisitorsOriginsLayer() {
  const { visitorsOriginsLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, visitorsOriginsLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });
  const day = useSelector((state) => state.app.day);
  const window = useSelector((state) => state.app.window);
  const dataOrigins = useSelector((state) => state.app.dataOrigins);
  const breaksOrigins = useSelector((state) => state.app.breaksOrigins);
  const visitorsOrigin = useSelector((state) => state.app.visitorsOrigin);
  const zoom = useSelector((state) => state.carto.viewState.zoom);
  const dispatch = useDispatch();
  const BUCKETS = VISUALS.buckets_origins;
  const credentials = useSelector((state) => state.carto.credentials);

  if (visitorsOriginsLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: VISITORS_ORIGINS_LAYER_ID,
      getFillColor: colorBins({
        attr: VISUALS.attr,
        domain: breaksOrigins,
        colors: VISUALS.secondary_palette,
      }),
      visible: visitorsOriginsLayer.visible && zoom >= 12,
      pointRadiusMinPixels: 2,
      pickable: true,
      getLineWidth: 0,
      opacity: 0.5,
      autoHighlight: true,
      highlightColor: [71, 219, 153],
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              includeColumns: [VISUALS.attr, "distance"],
              formatter: {
                type: "number",
                columns: [VISUALS.attr],
              },
            }),
            style: {},
          };
        }
      },
      onDataLoad: (data) => {
        //guardamos los datos
        dispatch(setDataOrigins(data));
        getMinMaxQuantiles({
          credentials,
          day_of_week: day,
          part_of_day: window,
          geoid: visitorsOrigin,
          buckets: BUCKETS,
        }).then((results) => {
          var breaks_layer = getEqualBreaks(
            results[0].min,
            results[0].max,
            BUCKETS
          );
          breaks_layer.push("100000000");
          dispatch(setBreaksOrigins(breaks_layer));
          var layerConfig = {
            title: "Number of visitors",
            // changing visible to true will make it show up on the map by default
            visible: false,
            switchable: false,
            legend: {
              attr: VISUALS.attr,
              type: LEGEND_TYPES.BINS,
              labels: getEqualBreaks(results[0].min, results[0].max, BUCKETS),
              colors: ["#fcde9c", "#e34f6f", "#7c1d6f"],
              //colors: VISUALS.secondary_palette,
              collapsible: false,
            },
          };
          dispatch(
            updateLayer({
              id: VISITORS_LAYER_ID,
              layerAttributes: {
                ...layerConfig,
              },
            })
          );
          cartoLayerProps.onDataLoad(data);
        });
      },
      updateTriggers: {
        getFillColor: [day, window, breaksOrigins, dataOrigins],
        ...cartoLayerProps.updateTriggers,
      },
    });
  }
}
